import type { VolunteerActivityType } from '@/queries/constants'

const DEFAULT_THRESHOLD_MIN = 180

export const DURATION_MIN_FLAG_THRESHOLD_MIN: Partial<Record<VolunteerActivityType, number>> = {
  'host-session-prep': 45,
}

export default function shouldFlagActivityDuration({
  durationMin,
  activityType,
}: {
  durationMin: number
  activityType: VolunteerActivityType
}): boolean {
  return durationMin > (DURATION_MIN_FLAG_THRESHOLD_MIN[activityType] ?? DEFAULT_THRESHOLD_MIN)
}
